import { z } from 'zod';

import i18n from '@/i18n';

export const LoginSchema = z.object({
    code: z.string().length(6, i18n.global.t('Kotan skal vera 6 tekin.')),
    verification_id: z.string(),
});
